module.exports = __webpack_public_path__ + "img/2025-06-11d_1.e71df058.jpg";